import zaludGeneral from './general/flow';
import noseSinuses from './noseSinuses/flow';
import throatPain from './throatPain/flow';
import coldFlu from './coldFlu/flow';
import pinkEye from './pinkEye/flow';
import earInfection from './earInfection/flow';
import zaludStiIntake from './stiTreatment/flow';
import zaludUtiTreatment from './utiTreatment/flow';
import yeastInfection from './yeastInfection/flow';
import bacterialVaginosis from './bacterialVaginosis/flow';

const ZaludFlows = {
  zaludGeneral,
  noseSinuses,
  throatPain,
  coldFlu,
  pinkEye,
  earInfection,
  zaludStiIntake,
  zaludUtiTreatment,
  yeastInfection,
  bacterialVaginosis
};

export default ZaludFlows;
